module.exports = __webpack_public_path__ + "img/to-your-head-desktop_644x734.403ad456.jpg";